import { render, staticRenderFns } from "./BankConnectionModalTinkUP.vue?vue&type=template&id=8f5888d6&scoped=true&"
import script from "./BankConnectionModalTinkUP.vue?vue&type=script&lang=js&"
export * from "./BankConnectionModalTinkUP.vue?vue&type=script&lang=js&"
import style0 from "./BankConnectionModalTinkUP.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BankConnectionModalTinkUP.vue?vue&type=style&index=1&id=8f5888d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5888d6",
  null
  
)

export default component.exports